<template>
  <div>
    <h3 class="mb-3">{{filterTypeName}}</h3>
    <div
      v-for="classItem in filtersRenderObject"
      :key="classItem.class"
      class="mt-2 align-content-center"
    >
      <h6 style="border-bottom: 1px solid #251e63;">{{classItem.class}}</h6>
      <b-container class="m-0">
        <b-row>
          <b-col
            :ref="selectItem.id"
            cols="auto"
            v-for="selectItem in classItem.levelList"
             :key="selectItem.description"
          >
            <MultiSelect
              style="margin-top: 3px;"
              v-model="selectItem.selectedValue"
              :options="selectItem.options"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="false"
              :placeholder="selectItem.description"
              @select="setOptions"
              @remove="removeChildOptions"
              @close="dropdownClose"
              label="name"
              track-by="name"
              :maxHeight="150"
              :preselect-first="true"
              :hide-selected="true"
              :show-labels="false"/>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  import { FilterObjectParameterBuilder, GeneralUtils } from '@/mixins/index'
  import MultiSelect from 'vue-multiselect'
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [FilterObjectParameterBuilder, GeneralUtils],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      height: {
        default: 100
      },
      filterType: {},
      filterTypeName: {},
      filterData: {}
    },
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      MultiSelect
    },
    data () {
      return {
        // productCategoryFilters: {},
        filtersRenderObject: [],
        style: null
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
      this.setInitRenderObject()
    },
    watch: {
    },
    computed: {
      vuexFilterObjectActiveInstance () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.filterRequestObject.activeFilterObjectInstance)
      },
      originalFilters () {
        return this.$_generalUtils_deepJsonCopy(this.filterData)
      },
      vuexFilterRenderObject () {
        return this.$store.state.filterRequestObject.selectedOptions
      },
      vuexIsSelectedFilters () {
        return this.$store.state.filterRequestObject.isSelectedFilters
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      setInitRenderObject () {
        let vuexUpdatedFilterRenderObject = this.$_generalUtils_deepJsonCopy(this.vuexFilterRenderObject[this.filterType])
        let a = this.$_generalUtils_deepJsonCopy(this.vuexIsSelectedFilters['store_filters'])
        let b = this.$_generalUtils_deepJsonCopy(this.vuexIsSelectedFilters['product_filters'])
        // let keepFilterCondition = this.$_generalUtils_deepJsonCopy(this.vuexIsSelectedFilters[this.filterType])
        // if keep condition is true, filters from previous views are keeped. Otherwise, the filter vuex store
        // will be reset and set the original filter settings
        if (a || b) {
          if (vuexUpdatedFilterRenderObject.length !== 0) {
            this.filtersRenderObject = vuexUpdatedFilterRenderObject
            this.buildFilterObject()
          } else {
            this.reset()
          }
        } else {
          this.reset()
        }
      },
      reset () {
        // this.$store.commit('commit_filterPane_resetState')
        let vuexOriginalFilterRenderObject = this.$_generalUtils_deepJsonCopy(this.originalFilters)
        this.filtersRenderObject = this.$_filterObjectParameterBuilder_setInitRenderObject(vuexOriginalFilterRenderObject)
        this.buildFilterObject()
        this.setIsSelectedFilters()
        this.commitSelectedOptions()
      },
      emitReloadData () {
        this.$eventHub.$emit('filter-pane-filter-update')
      },
      buildFilterObject () {
        // Will build up the filter object given the selected options from selectors in UI
        let vuexFilterObjectActiveInstanceCopy = this.$_generalUtils_deepJsonCopy(this.vuexFilterObjectActiveInstance)
        let filter = this.$_filterObjectParameterBuilder_buildFilterObject(this.filtersRenderObject, this.filterType, vuexFilterObjectActiveInstanceCopy)
        this.$store.commit('filterRequestObject/commit_filterRequestObject_activeFilterObjectInstance', filter)
      },
      dropdownClose () {
        this.buildFilterObject()
        this.setIsSelectedFilters()
      },
      setOptions (selection) {
        // Set options for selector with child levels.
        let originalFilters = this.$_generalUtils_deepJsonCopy(this.originalFilters)
        let renderObject = this.$_generalUtils_deepJsonCopy(this.filtersRenderObject)
        let b = this.$_filterObjectParameterBuilder_setChildOptions(selection, renderObject, originalFilters)
        this.filtersRenderObject = b
        this.commitSelectedOptions()
        this.setIsSelectedFilters()
      },
      removeChildOptions (selection) {
        // Clean Selectors for single and nested selectors Parent -> child:
        let cleanObjects = this.$_filterObjectParameterBuilder_clearSelectorsGivenRemovedOption(
          selection, this.$_generalUtils_deepJsonCopy(this.originalFilters),
          this.$_generalUtils_deepJsonCopy(this.filtersRenderObject))
        this.filtersRenderObject = cleanObjects
        this.buildFilterObject()
        this.setIsSelectedFilters()
      },
      setIsSelectedFilters () {
        let a = this.$_filterObjectParameterBuilder_checkIfObjectContainsSelections(this.filtersRenderObject)
        let payload = {'filterType': this.filterType, 'value': a}
        if (a) {
          this.$store.commit('filterRequestObject/commit_filterRequestObject_isSelectedFilters', payload)
        } else {
          this.$store.commit('filterRequestObject/commit_filterRequestObject_isSelectedFilters', payload)
        }
      },
      commitSelectedOptions () {
        let payload = {'filtersRenderObject': this.filtersRenderObject, 'filterType': this.filterType}
        this.$store.commit('filterRequestObject/commit_filterRequestObject_selectedOptions', payload)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/FilterPane/FilterSelectorLogic.vue